import Vue from 'vue'
import Router from 'vue-router'
import login from '@/views/login.vue'
import Index from '@/views/indexPage/Index.vue'
import Order from '@/views/orderPage/Order.vue'
import Personnel from '@/views/personnelPage/Personnel.vue'
import Account from '@/views/accountPage/Account.vue'
import Subpro from '@/views/subproPage/Subpro.vue'
import {delCookie,getCookie} from '@/util/util'


Vue.use(Router)

const routes =
 [
    {
      path:"/",
      name: 'login',
      meta: {
        name: '登录',
      },
      component: login,
    },
    {
      path: '/Index',
      name: 'Index',
      meta: {
        name: '首页',
      },
      component: Index,
    },
     {
      path: '/Order',
      name: 'Order',
      meta: {
        name: '订单',
      },
      component: Order,
    },
    {
      path:'/Personnel',
      name:'Personnel',
      meta:{
        name:'人员',
        },
        component: Personnel,
    },
    {
      path:'/Account',
      name:'Account',
      meta:{
        name:'账户',
        },
        component: Account,
    },
    {
      path:'/Subpro',
      name:'Subpro',
      meta:{
        name:'下级代理',
        },
        component: Subpro,
    }
  ];

// export default new Router({
//   routes: [
//       {
//         path:"/",
//         name: 'login',
//         meta: {
//           name: '登录',
//         },
//         component: login,
//       },
//       {
//         path: '/Index',
//         name: 'Index',
//         meta: {
//           name: '首页',
//         },
//         component: Index,
//       },
//        {
//         path: '/Order',
//         name: 'Order',
//         meta: {
//           name: '订单',
//         },
//         component: Order,
//       },
//       {
//         path:'/Personnel',
//         name:'Personnel',
//         meta:{
//           name:'人员',
//           },
//           component: Personnel,
//       },
//       {
//         path:'/Account',
//         name:'Account',
//         meta:{
//           name:'账户',
//           },
//           component: Account,
//       },
//       {
//         path:'/Subpro',
//         name:'Subpro',
//         meta:{
//           name:'下级代理',
//           },
//           component: Subpro,
//       }
//     ]
// });

const router = new Router({
    routes
});

// 备注：请注意路由中的 meta:{requireAuth: true }，这个配置，主要为下面的验证做服务。
// if(to.meta.requireAuth)，这段代码意思就是说，如果requireAuth: true ,那就判断用户是否存在。
// 如果存在，就继续执行下面的操作，如果不存在，就删除客户端的Cookie,同时页面跳转到登录页，代码如下。
//这个是请求页面路由的时候会验证token存不存在，不存在的话会到登录页
router.beforeEach((to, from, next) => {
  if(to.meta.requireAuth) {
    fetch('/api/account/login').then(res => {
      if(res.data.retCode == 200) {
        next();
      } else {
        if(getCookie('session')) {
          delCookie('session');
        }
        if(getCookie('userType')) {
          delCookie('userType');
        }
        if(getCookie('userNum')) {
          delCookie('userNum');
        }
        if(getCookie('productId')) {
          delCookie('productId');
        }
        if(getCookie('salePrice')) {
          delCookie('salePrice');
        }
        if(getCookie('outTradeNo')) {
          delCookie('outTradeNo');
        }
        // 获取创建人id
        if(getCookie('userid')) {
          delCookie('userid');
        }
        // 获取产品id
        if(getCookie('id')) {
          delCookie('id');
        }
        // 获取账户余额
        if(getCookie('wallet')) {
          delCookie('wallet');
        }
        // 获取省编码
        if(getCookie('areacode')) {
          delCookie('areacode');
        }
        next({
          path: '/'
        });
      }
    });
  } else {
    next();
  }
});
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js